import { render, staticRenderFns } from "./DashboardAsideLinks.vue?vue&type=template&id=84ccfc52&scoped=true"
import script from "./DashboardAsideLinks.vue?vue&type=script&lang=js"
export * from "./DashboardAsideLinks.vue?vue&type=script&lang=js"
import style0 from "./DashboardAsideLinks.vue?vue&type=style&index=0&id=84ccfc52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ccfc52",
  null
  
)

export default component.exports